import { render } from "./B2bTableMenuDeliveryNotesReceived.vue?vue&type=template&id=d4c2dbb2&scoped=true&lang=pug"
import script from "./B2bTableMenuDeliveryNotesReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuDeliveryNotesReceived.vue?vue&type=script&lang=js"

import "./B2bTableMenuDeliveryNotesReceived.vue?vue&type=style&index=0&id=d4c2dbb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c2dbb2"]])

export default __exports__